const release = '1.15.0'

module.exports = release



//////////////////
// WEBPACK FOOTER
// ./release.js
// module id = immm
// module chunks = 1624